import { cn } from "@/utils/helpers";
import { ReactNode } from "react";

type StatusTextProps = {
  variant?: "loading" | "success" | "error" | "warning" | "suggestion" | "nothing";
  className?: string;
  children: ReactNode;
};

export default function StatusText({ variant, className, children }: StatusTextProps) {
  let icon;

  switch (variant) {
    case "loading":
      icon = "🟡";
      break;
    case "error":
      icon = "⚠️";
      break;
    case "warning":
      icon = "❗";
      break;
    case "success":
      icon = "✅";
      break;
    case "suggestion":
      icon = "✨";
      break;
    case "nothing":
      icon = "🙂";
      break;
    default:
      icon = "";
  }

  return <p className={cn("text-sm text-muted-foreground", className)}>{variant ? `${icon} ${children}` : children}</p>;
}
